// Shared procedure-ordering helper for the patient-facing views (Itemized,
// Arch & Region).
//
// Procedures are ordered by their Open Dental treatment-plan PRIORITY value
// (proc.priorityName, which is the priority definition's ItemName — "1",
// "2", "Next", "Low", ...):
//   1. Numeric priorities ("1","2","3"...) first, ascending by numeric value.
//   2. Custom-named priorities ("Next","Low","Wait"...) next.
//   3. Uncategorized (no priority → blank name) last.
//
// This deliberately sorts inside the views rather than relying on upstream
// order, so a stale/partial drag-order (proceduresOrder) — which only drives
// the left-panel TC workflow — never bleeds into what the patient sees. To
// change the order, the practice changes the OD priority and it flows through.

function priorityBucket(name) {
  const n = (name == null ? '' : String(name)).trim();
  if (!n) return 2;               // uncategorized → last
  if (/^\d+$/.test(n)) return 0;  // numeric priorities → first
  return 1;                       // custom-named → middle
}

/**
 * CDT diagnostic codes (exams, x-rays) = D0xxx. Used to let the TC toggle
 * exams/x-rays in/out of the presentation. Non-CDT systems (Canada/South
 * Africa) are filtered server-side instead, so this only needs to match D0.
 */
export function isDiagnosticCode(procCode) {
  return /^d0/i.test(String(procCode || '').trim());
}

export function comparePriority(a, b) {
  const ba = priorityBucket(a && a.priorityName);
  const bb = priorityBucket(b && b.priorityName);
  if (ba !== bb) return ba - bb;
  if (ba === 0) {
    return parseInt(a.priorityName, 10) - parseInt(b.priorityName, 10);
  }
  return 0; // stable: keep incoming order within named / uncategorized groups
}

/**
 * Returns a new array sorted by priority. Array.prototype.sort is stable in
 * modern engines, so procedures sharing a priority keep their incoming order
 * (the backend already returns them in ItemOrder/ProcNum order).
 */
export function sortByPriority(procs) {
  return [...(procs || [])].sort(comparePriority);
}
